import { NgModule, EventEmitter } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { Hplc1Component } from './hplc1/hplc1.component';
import { Hplc2Component } from './hplc2/hplc2.component';
import { Hplc3Component } from './hplc3/hplc3.component';
import { HplcselectComponent } from './hplcselect/hplcselect.component';
import { View1Component } from './view1/view1.component';
import { View2Component } from './view2/view2.component';
import { IntroComponent } from './intro/intro.component';
import { ConstructionComponent } from './construction/construction.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', component: IntroComponent },
  { path: 'intro', component: IntroComponent, data: { state: 'intro'} },
  { path: 'select', component: HplcselectComponent, data: { state: 'select'} },
  { path: 'hplc1', component: Hplc1Component, data: { state: 'hplc1'} },
  { path: 'hplc2', component: Hplc2Component, data: { state: 'hplc2'} },
  { path: 'hplc3', component: Hplc3Component, data: { state: 'hplc3'} },
  { path: 'view1', component: View1Component, data: { state: 'view1'} },
  { path: 'view2', component: View2Component, data: { state: 'view2'} },
  { path: 'construction', component: ConstructionComponent, data: { state: 'construction'} },
  { path: '', component: IntroComponent, data: { state: 'intro'} },

    // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const AppRouting = RouterModule.forRoot(routes, {
  useHash: false
});
